import { Component, OnInit, OnDestroy } from '@angular/core';
import { DrawerService } from '../drawer.service';
import { LoginComponent } from './../auth/login/login.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  inCheckOut: boolean = false;

  totalCount: number = 0
  public totalCountSub: Subscription;

  isAuthenticated: boolean = false;
  isAuthenticatedSub: Subscription;

  constructor(private authService: AuthService, private snackBar: MatSnackBar, private drawerStateService: DrawerService, private cartService: CartService, private dialog: MatDialog, private route: Router) { }

  ngOnInit() {
    if (this.route.url === '/checkout') {
      this.inCheckOut = true;
    } else {
      this.inCheckOut = false;
    }

    const onloadData = this.cartService.onLoad();
    this.totalCount = onloadData.totalCount;

    this.isAuthenticated = this.authService.getIsUserAuthenticated();

    // subscribe to total count subject
    this.totalCountSub = this.cartService.getTotalCountUpdated().subscribe(result => {
      this.totalCount = result;
    });

    // subscribe to user authenticated subject
    this.isAuthenticatedSub = this.authService.getIsUserAuthenticatedUpdated().subscribe(result => {
      this.isAuthenticated = result;
    })

    this.isAuthenticated = this.authService.getIsUserAuthenticated();

    // subscribe to user authenticated subject
    this.isAuthenticatedSub = this.authService.getIsUserAuthenticatedUpdated().subscribe(result => {
      this.isAuthenticated = result;
    })
  }

  onCartClick() {
    this.drawerStateService.setDrawerState(true);
  }

  onMobileMenu() {
    this.drawerStateService.setMobileNAvDrawerState(true);
  }

  onCheckout() {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    localStorage.setItem('clickedStatus', 'checkout');

    if (!localBaskets && !localLeaves && !localDressings) {
      this.snackBar.open('Cart is empty!', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (this.isAuthenticated) {
      this.route.navigate(['/checkout']);
    } else {
      this.dialog.open(LoginComponent);
      return;
    }
  }

  onProfile() {
    localStorage.setItem('clickedStatus', 'profile');

    if (this.isAuthenticated) {
      this.route.navigate(['/profile']);
    } else {
      this.dialog.open(LoginComponent);
      return;
    }
  }

  onSignIn() {
    this.dialog.open(LoginComponent);
  }

  onLogout() {
    this.authService.userLogout();
  }

  onClickHome() {
    this.route.navigate(['/']);
  }

  ngOnDestroy() {
    this.totalCountSub.unsubscribe();
    this.isAuthenticatedSub.unsubscribe();
  }
}